export default {
    en: {
        upload: {
            labelInvalidField: 'Field contains invalid files',
            labelFileWaitingForSize: 'Waiting for size',
            labelFileSizeNotAvailable: 'Size not available',
            labelFileLoading: 'Loading',
            labelFileLoadError: 'Error during load',
            labelFileProcessing: 'Uploading',
            labelFileProcessingComplete: 'Upload complete',
            labelFileProcessingAborted: 'Upload cancelled',
            labelFileProcessingError: 'Error during upload',
            labelFileProcessingRevertError: 'Error during revert',
            labelFileRemoveError: 'Error during remove',
            labelTapToCancel: 'tap to cancel',
            labelTapToRetry: 'tap to retry',
            labelTapToUndo: 'tap to undo',
            labelButtonRemoveItem: 'Remove',
            labelButtonAbortItemLoad: 'Abort',
            labelButtonRetryItemLoad: 'Retry',
            labelButtonAbortItemProcessing: 'Cancel',
            labelButtonUndoItemProcessing: 'Undo',
            labelButtonRetryItemProcessing: 'Retry',
            labelButtonProcessItem: 'Upload',
            labelMaxFileSizeExceeded: 'File is too large',
            labelMaxFileSize: 'Maximum file size is {filesize}',
            labelMaxTotalFileSizeExceeded: 'Maximum total size exceeded',
            labelMaxTotalFileSize: 'Maximum total file size is {filesize}',
            labelFileTypeNotAllowed: 'File of invalid type',
            fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
        },
        dataloader: {
            error: 'An error occurred'
        },
        datepicker: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        }
    },
    de_CH: {
        upload: {
            labelInvalidField: 'Feld beinhaltet ungültige Dateien',
            labelFileWaitingForSize: 'Dateigröße berechnen',
            labelFileSizeNotAvailable: 'Dateigröße nicht verfügbar',
            labelFileLoading: 'Laden',
            labelFileLoadError: 'Fehler beim Laden',
            labelFileProcessing: 'Upload läuft',
            labelFileProcessingComplete: 'Upload abgeschlossen',
            labelFileProcessingAborted: 'Upload abgebrochen',
            labelFileProcessingError: 'Fehler beim Upload',
            labelFileProcessingRevertError: 'Fehler beim Wiederherstellen',
            labelFileRemoveError: 'Fehler beim Löschen',
            labelTapToCancel: 'abbrechen',
            labelTapToRetry: 'erneut versuchen',
            labelTapToUndo: 'rückgängig',
            labelButtonRemoveItem: 'Entfernen',
            labelButtonAbortItemLoad: 'Verwerfen',
            labelButtonRetryItemLoad: 'Erneut versuchen',
            labelButtonAbortItemProcessing: 'Abbrechen',
            labelButtonUndoItemProcessing: 'Rückgängig',
            labelButtonRetryItemProcessing: 'Erneut versuchen',
            labelButtonProcessItem: 'Upload',
            labelMaxFileSizeExceeded: 'Datei ist zu groß',
            labelMaxFileSize: 'Maximale Dateigröße: {filesize}',
            labelMaxTotalFileSizeExceeded: 'Maximale gesamte Dateigröße überschritten',
            labelMaxTotalFileSize: 'Maximale gesamte Dateigröße: {filesize}',
            labelFileTypeNotAllowed: 'Dateityp ungültig',
            fileValidateTypeLabelExpectedTypes: 'Erwartet {allButLastType} oder {lastType}',
        },
        dataloader: {
            error: 'Ein Fehler ist aufgetreten.'
        },
        datepicker: {
            previousMonth : 'vorheriger Monat',
            nextMonth     : 'nächster Monat',
            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
            weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
            weekdaysShort : ['So','Mo','Di','Mi','Do','Fr','Sa']
        }
    }
}
